export default ({ department, sector, position, type, employee }) => {
  return [
    {
      label: 'Нэр',
      name: 'name',
      className: 'col-span-12 mb-1',
      inputProps: {
      }
    },
    {
      label: 'РД',
      name: 'registerno',
      className: 'col-span-12 mb-1',
      inputProps: {
      }
    },
    {
      label: 'Утас',
      name: 'phone',
      type: 'number',
      className: 'col-span-12 mb-1',
      inputProps: {
        
      }
    },
    {
      label: 'Мэйл',
      name: 'email',
      className: 'col-span-12 mb-1',
      inputProps: {

      }
    },
  ]
}